'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { type ReactNode, useEffect, useRef } from 'react';
import { MdClose } from 'react-icons/md';
import { useIsMounted, useOnClickOutside } from 'usehooks-ts';
import styles from './modal-old.module.scss';
export interface ModalOldProps {
  isActive: boolean;
  onClose: () => void;
}
interface ModalWithChildrenProps extends ModalOldProps {
  children: ReactNode;
}

// TODO: replace place of usage with component Modal
export default function ModalOld(props) {
  const $ = _c(12);
  const {
    children,
    isActive,
    onClose
  } = props;
  const isMounted = useIsMounted();
  const modalContentRef = useRef(null);
  useOnClickOutside(modalContentRef, onClose);
  let t0;
  if ($[0] !== isMounted) {
    t0 = [isMounted];
    $[0] = isMounted;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEffect(_temp2, t0);
  const t1 = isActive && styles.modalOld__isActive;
  let t2;
  if ($[2] !== t1) {
    t2 = cx(styles.modalOld, t1);
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onClose) {
    t3 = <div className={styles.modalOld_close}><MdClose onClick={onClose} /></div>;
    $[4] = onClose;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children || $[7] !== t3) {
    t4 = <div ref={modalContentRef} className={styles.modalOld_content}>{t3}{children}</div>;
    $[6] = children;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className={t2}>{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp2() {
  document.body.style.overflow = "hidden";
  return _temp;
}
function _temp() {
  document.body.style.overflow = "unset";
}